import { Button, Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { t } from 'i18next';
import React from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

interface UserConsentProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
  isLoading: boolean;
}

function ConsentBulletPoint({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex__dir--row">
      <p className="font-size-xs m-right-l">&bull;</p>
      <p className="font-size-m p-bottom-xxs">{children}</p>
    </div>
  );
}

export function UserConsent({
  isOpen,
  onAccept,
  onDecline,
  isLoading,
}: UserConsentProps) {
  return (
    <Dialog isOpen={isOpen} className="w-max-4xl" hideCloseButton>
      <div className="flex flex__dir--column text-align-left">
        <div className="flex flex__ai--center">
          <Icon
            name="chatbot_unmasked"
            size={IconSizeClasses.Medium}
            className="m-right-m"
          />
          <Dialog.Title className="m-bottom-xxs">
            {t('chatbot.consentHeader')}
          </Dialog.Title>
        </div>
        <Dialog.Description />
        <div className="m-top-xxs">{t('chatbot.consentText')}</div>
        <div
          className="flex flex__dir--column p-m border-color-blue-500 bg-blue-50 border-solid border-radius-xl m-top-l"
          style={{ borderWidth: '1px' }}
        >
          <p className="m-bottom-s font-weight-bold">{t('chatbot.consentTextSubText')}</p>
          <ConsentBulletPoint>{t('chatbot.consentBullet1')}</ConsentBulletPoint>
          <ConsentBulletPoint>
            <Trans
              i18nKey="chatbot.consentBullet2"
              components={{
                l: (
                  <Link
                    target="_blank"
                    to="/privacypolicy.html"
                    className="color-blue-500"
                  />
                ),
              }}
            />
          </ConsentBulletPoint>
          <ConsentBulletPoint>
            <Trans
              i18nKey="chatbot.consentBullet3"
              components={{
                l: (
                  <Link
                    target="_blank"
                    to="https://eppendorf.atlassian.net/servicedesk/customer/portals"
                    className="color-blue-500"
                  />
                ),
              }}
            />
          </ConsentBulletPoint>
        </div>
      </div>

      <Dialog.Actions>
        <div className="flex gap-m flex__jc--flex-end">
          <Button variant="secondary" onClick={onDecline} disabled={isLoading}>
            {t('chatBot.consentCancel', 'Cancel')}
          </Button>
          <Button
            variant="primary"
            id="acceptConsentButton"
            onClick={onAccept}
            disabled={isLoading}
          >
            {t('chatBot.consentContinue', 'Continue')}
          </Button>
        </div>
      </Dialog.Actions>
    </Dialog>
  );
}
